import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ClientService } from '@/service/client.service';
import { Client } from '@/dto/client/client';
import { finalize } from "rxjs/operators";
import { SpinnerService } from '@/service/spinner.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UserService } from '@/service/user.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastController } from '@ionic/angular';
import { HttpClient } from '@angular/common/http';



@Component({
  selector: 'app-clientedit',
  templateUrl: './clientedit.page.html',
  styleUrls: ['./clientedit.page.scss']
})

export class ClientEditPage implements OnInit, OnDestroy {
  @ViewChild('selectOption') selectOption: any;
  navigationSubscription
  public dataForm: FormGroup;
  public cert_key_file: File;
  public cert_crt_file: File;
  public cert_ca_file: File;

  public cert_key_str:string='';
  public cert_crt_str:string='';
  public cert_ca_str:string='';
  private newClient: boolean;
  public fd: FormData;
  public pageIndex = 1;
  public pageSize: number;
  public total: number;
  public pageSizeOpts: number[];
  private unsubscribe: Subscription[] = [];
  private submitted = false;
  public listUser: any[] = [];
  public isError = true
  private idclient: string;
  public dataApiKey = [{
    id: '',
    key: '',
    secret: '',
    active: false,
    default: false,
    delete: false
  }]

  constructor(private formBuilder: FormBuilder, public clientService: ClientService, private spinnerService: SpinnerService,
    public router: Router, private route: ActivatedRoute, public toastController: ToastController, public userService: UserService,
    private translateService: TranslateService, private http: HttpClient) {

  }

  newRowAPI() {
    // if(this.isEmptyRowAPI()) return alert('Cannot add')
    this.dataApiKey.push({
      id: '',
      key: '',
      secret: '',
      active: false,
      default: false,
      delete: false
    })
  }

  isEmptyRowAPI() {
    let arrAPI = this.dataApiKey
    for (let i = 0; i < arrAPI.length; i++) {
      if (arrAPI[i].key.trim().length === 0 || arrAPI[i].secret.trim().length === 0) return true
    }
    return false
  }

  deleteRowAPI(index) {
    this.dataApiKey[index]["delete"] = true;
    //this.dataForm.controls['api'].setValue(this.dataApiKey.splice(index, 1))
  }

  changeKey(i, event) {
    this.dataApiKey[i]["key"] = event.target.value;
  }

  changeSecret(i, event) {
    this.dataApiKey[i]["secret"] = event.target.value;
  }

  changeDefault(i, event) {
    this.dataApiKey[i]["default"] = event.detail.checked ? true : false;
  }

  changeActive(i, event) {
    this.dataApiKey[i]["active"] = event.detail.checked ? true : false;
  }

  setValueAPI(e, key, index) {
    let newDataRow = this.dataApiKey[index]
    newDataRow[key] = e.target.value
    const newDataAPI = this.dataApiKey.splice(index, 1, newDataRow)
    this.dataApiKey = newDataAPI
    this.dataForm.controls['api'].setValue(newDataAPI)
  }

  initialiseInvites() {
    this.submitted = false;
    this.dataForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      barcode_prefix: ['', [Validators.required]],
      client_id: ['', [Validators.required]],
      sector: ['', [Validators.required]],
      url_cart_validation: ['', [Validators.required]],
      url_cart_expiration: ['', [Validators.required]],
      is_wallet: false,
      client_agg_id: [''],
      url_trx_identity: ['', [Validators.required]],
      url_trx_amount: ['', [Validators.required]],
      url_trx_confirmation: ['', [Validators.required]],
      user_id: ['', []],
      api: [[]],
      is_certificate: false,
      deleteKey: false,
      deleteCrt:false,
      deleteCa:false,
      send_email: false,
      minimum_amount: 0
    });

    this.idclient = this.route.snapshot.queryParams['idClient'];


    if (this.idclient) {
      this.unsubscribe.push(this.clientService.getById(this.idclient).pipe(finalize(() => {
        this.spinnerService.hide();
      }))
        .subscribe(
          data => {

            if (data) {
              this.dataForm.patchValue({//data here to patch
                name: data.name,
                barcode_prefix: data.barcode_prefix,
                client_id: data.client_id,
                sector: data.Sector,
                url_cart_validation: data.url_cart_validation,
                url_cart_expiration: data.url_cart_expiration,
                is_wallet: data.is_wallet,
                url_trx_identity: data.url_trx_identity,
                url_trx_amount: data.url_trx_amount,
                url_trx_confirmation: data.url_trx_confirmation,
                user_id: data.user_id,
                client_agg_id: data.client_agg_id,
                is_certificate: data.is_certificate,
                cert_key: data.cert_key.value,
                cert_crt: data.cert_crt.value,
                cert_ca:data.cert_ca.value,
                deleteKey:false,
                deleteCrt:false,
                deleteCa:false,
                send_email: data.send_email,
                minimum_amount: data.minimum_amount
              });
              this.cert_crt_str = data.cert_crt;
              this.cert_key_str = data.cert_key;
              this.cert_ca_str = data.cert_ca;

                this.loadUsers(data);

              this.dataApiKey = data.listapi;
              this.dataApiKey.forEach(c => {
                c["delete"] = false;
              })
            }
          }));
    } else
      this.loadUsers(null);
  }

  loadUsers(data) {
    this.unsubscribe.push(
      this.userService.get().pipe(finalize(() => {
      })).subscribe(val => {
        this.listUser = val;
        if (data !== null)
          this.selectOption.nativeElement.setAttribute('placeholder', this.listUser.find(c => c.id === data.user_id).text);
      })
    );
  }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd && (event.url.includes('/admin/editclient') ||
        event.url === '/admin/newclient')) {
        this.initialiseInvites()
      }
    });

  }

  ngOnDestroy() {
    this.unsubscribe.forEach(s => s.unsubscribe());
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  cancel() {
    this.router.navigate(['/admin/client']);
  }

  async onSubmit() {

    this.dataForm.markAllAsTouched();
    if (this.dataForm.invalid || this.submitted) {
      return;
    }
    this.submitted = true;
    const fd = new FormData();
    const client = new Client();

    fd.append('id', this.idclient);
    fd.append('name', this.f.name.value);
    fd.append('barcode_prefix', this.f.barcode_prefix.value);
    fd.append('client_id', this.f.client_id.value);
    fd.append('sector', this.f.sector.value);
    fd.append('url_cart_validation', this.f.url_cart_validation.value);
    fd.append('url_cart_expiration', this.f.url_cart_expiration.value);
    fd.append('is_wallet', this.f.is_wallet.value !== undefined ? this.f.is_wallet.value : false);
    fd.append('url_trx_identity', this.f.url_trx_identity.value);
    fd.append('url_trx_amount', this.f.url_trx_amount.value);
    fd.append('url_trx_confirmation', this.f.url_trx_confirmation.value);
    //fd.append('user_id', this.parseValueFromUserInput(this.f.user_id.value));
    fd.append('apis', JSON.stringify(this.dataApiKey));
    fd.append('client_agg_id', this.f.client_agg_id.value);
    fd.append('is_certificate', this.f.is_certificate.value !== undefined ? this.f.is_certificate.value : false);
    fd.append('send_email', this.f.send_email.value !== undefined ? this.f.send_email.value : false);
    fd.append('minimum_amount', this.f.minimum_amount.value);

    console.log("cert_key_chekbox:", this.f.deleteKey);
    console.log("cert_crt_chekbox:", this.f.deleteCrt);
    console.log("cert_ca_chekbox:", this.f.deleteCa);

    if (this.cert_key_file) {
      fd.append('cert_key', this.cert_key_file);

      fd.append('is_key', "True");
    }
   else if(this.f.deleteKey.value){
      fd.append('cert_key', "");
      fd.append('is_key', "True");
    }
   else {
      fd.append('is_key', "False");
    }

    if (this.cert_crt_file) {
      fd.append('cert_crt', this.cert_crt_file);
      fd.append('is_cert', "True");
    }
    else if(this.f.deleteCrt.value){
      fd.append('cert_crt', "");
      fd.append('is_cert', "True");
    }
    else {
      fd.append('is_cert', "False");
    }
    if (this.cert_ca_file) {
      fd.append('cert_ca', this.cert_ca_file);
      fd.append('is_ca', "True");
    }
    else if(this.f.deleteCa.value){
      fd.append('cert_ca', "");
      fd.append('is_ca', "True");
    }
    else {
      fd.append('is_ca', "False");
    }

    if (JSON.parse(fd.get('apis').toString()).filter(c => c.default && c.delete === false).length > 1) {
      this.submitted = false;
      let message = this.translateService.instant("OnlyOneDefaultApi")
      const toast = await this.toastController.create({
        message: message,
        duration: 2000
      });
      toast.present()
      return;
    }

    this.spinnerService.show();

    // EDIT

    this.unsubscribe.push(this.clientService.modify(fd).pipe(finalize(() => {
      this.spinnerService.hide();
      this.submitted = false;
    }))
      .subscribe(
        async data => {
          if (data["response"] === "OK") {
            let message = this.translateService.instant("Client.Text.Saved")
            const toast = await this.toastController.create({
              message: message,
              duration: 2000
            });
            toast.present()
            this.router.navigate(['/admin/client/']);

            this.submitted = false;
          }
        }));
  }

  get f() { return this.dataForm.controls; }

  // SELECT OPTION CUSTOMER
  handleChangeUser(e) {
    let txt_placeholder = e.target.value || ''
    this.selectOption.nativeElement.value = ''
    this.dataForm.patchValue({
      user_id: txt_placeholder
    })
    this.selectOption.nativeElement.setAttribute('placeholder', txt_placeholder)
  }

  parseValueFromUserInput(value: string) {
    for (let i = 0; i < this.listUser.length; i++) {
      if (this.listUser[i].text == value) return this.listUser[i].id
    }
    return ""
  }

  async handleKeyFile(event: any) {
    this.cert_key_file = event.target.files[0];
    this.dataForm.patchValue({ cert_key: this.cert_key_file });
  }

  async handleCrtFile(event: any) {
    this.cert_crt_file = event.target.files[0];
    this.dataForm.patchValue({ cert_crt: this.cert_crt_file });
  }
  async handleCaFile(event: any) {
    this.cert_ca_file = event.target.files[0];
    this.dataForm.patchValue({ cert_ca: this.cert_ca_file });
  }
}
